<template>
	<view class="box">
		<filter-box :categories1="scenes" :categories2="categories" :cid1="pagination.scene" :cid2="pagination.cid"
			@change="filterChange"></filter-box>

		<view class="section-box" v-if="list&&list.length>0">
			<view class="box">
				<bbs-item v-for="(item,index) in list" :key="index" :item="item"></bbs-item>
			</view>

		</view>
		<empty v-else :loading="loading"></empty>

		<view class="loadmore" v-if="list&&list.length>0">
			<u-loadmore @loadmore="getData(true)" :status="loadStatus" />
		</view>
		<view class="add-btn" @click="add()">
			<u-icon name="edit-pen" color="#848484" size="60"></u-icon>
		</view>
	</view>
</template>

<script>
	import bbsItem from '../../components/bbs-item'
	var that; // 当前页面对象
	var vk; // vk依赖
	export default {
		components: { bbsItem },
		data() {
			return {
				scenes: [{
						id: "default",
						name: "全部",
					},
					{
						id: "last_answer",
						name: "最新",
					},
					{
						id: "unsolved",
						name: "未解决",
					},
					{
						id: "solved",
						name: "已解决",
					}
				],
				list: [],
				pagination: {
					pageIndex: 1,
					pageSize: 10,
					scene: 0,
					cid: 0,
				},
				categories: [],
				over: false,
				loading: false,
			};
		},
		computed: {
			loadStatus() {
				if (this.over) {
					return "nomore";
				}
				if (this.loading) {
					return "loading";
				}
				return "loadmore";
			},
		},
		onLoad(options) {
			that = this;
			vk = that.vk;
			this.pagination.scene = options.scene ?? 'default'
			this.pagination.cid = options.cid ?? 0

			this.getData();
			this.getCategories();
		},
		onReachBottom() {
			this.getData(true);
		},
		onPullDownRefresh() {
			this.resetData();
			this.getData();
			setTimeout(() => {
				uni.stopPullDownRefresh()
			}, 500);
		},
		methods: {
			add(){
				uni.vk.navigateTo('/uni_modules/uce-bbs/pages/submit/submit')
			},
			filterChange(scene, cid) {
				this.pagination.scene = scene;
				this.pagination.cid = cid;
				this.resetData();
				this.getData();
			},
			resetData() {
				this.list = [];
				this.pagination.pageIndex = 1;
				this.over = false;
			},
			getCategories() {
				vk.callFunction({
					url: 'client/bbs/pub/categories',
					success(data) {
						let categories = [];
						categories.push(...data.rows);
						console.log(categories)
						that.categories.push(...categories);
					}
				});
			},
			getData(more = false) {
				if (this.loading) {
					return;
				}
				if (more) {
					this.pagination.pageIndex++;
				}
				this.loading = true;

				vk.callFunction({
					url: 'client/bbs/pub/getList',
					data: that.pagination,
					success(data) {
						let list = data.rows;
						if (list.length > 0) {
							that.list.push(...list);
						}
						setTimeout(() => {
							that.loading = false;
							if (list.length < that.pagination.pageSize) {
								that.over = true;
							}
						}, 200);
					}
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	page {
		background: #f4f6f8;
	}

	.section-box {
		position: relative;
		display: flex;
		flex-direction: column;
		background: #f4f6f8;
		padding: 20rpx;

		.box {
			position: relative;
			padding: 0 20rpx;
			background: #FFFFFF;
		}
	}

	.add-btn {
		position: fixed;
		right: 20rpx;
		bottom: 300rpx;
		width: 90rpx;
		height: 90rpx;
		border: 1px solid #eee;
		background-color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
